@if (config.defaultsetting) {
  <div>
    <div class="col-md-3 mt-3 ml-n2">
      @if (config.resource == undefined) {
        <form [formGroup]="config.form">
          <kx-multiselect-dropdown
            [value]="'catalog_entry'"
            [settings]="config.defaultsetting"
            [placeholder]="'Select Resource'" [controlName]="config.form"
            [setId]="config.resourceDatasource.key"
            [questions]="config.resourceDatasource" [data]="config.datasource" (onSelect)="changeResource($event)"
            (onDeSelect)="changeResource($event)">
          </kx-multiselect-dropdown>
        </form>
      }
      <!-- <span *ngIf="config.resource != undefined"> Selected Resource: <b>{{config.resource}}</b></span> -->
    </div>
  </div>
}
@if (config.resourceName) {
  <div>
    <app-ui-engine [decoratorname]="'ResourceLoaderDecorator'" [resourcename]="config.resourceName" [current_action]="config.currentAction"></app-ui-engine>
  </div>
}